{
  "taskList": {
    "title": "Tasks",
    "buttons": {
      "openPriorityTask": "Open Priority Task",
      "viewMyQueue": "View My Queue"
    },
    "viewToggle": {
      "table": "Table",
      "calendar": "Calendar"
    },
    "emptyState": {
      "title": "No tasks found.",
      "description": "Try adjusting your filters or search criteria."
    }
  },
  "taskQueue": {
    "title": "Your Tasks Queue",
    "description": "Tasks are ordered by urgency and due date in a centralized view. The first one is what you'll see when you click 'Work on Top Task'.",
    "nextUp": "Next Up",
    "order": "Order",
    "taskCount": "{{count}} tasks in your queue",
    "emptyState": "No tasks in your queue."
  }
}
